import { Modal } from "bootstrap";

const initHeaderSearchModal = () => {
  const openSearchBtn = document.querySelector(".js-header-search-modal-open-btn");
  const searchModalEl = document.querySelector(".js-header-search-modal");
  const searchForm = searchModalEl.querySelector("form");
  const searchInput = searchForm.querySelector("input[type='search']");
  const submitBtn = searchForm.querySelector("button[type='submit']");
  // eslint-disable-next-line no-undef
  const modal = new Modal(searchModalEl, {
    backdrop: true,
    keyboard: true,
    focus: true,
  });

  const seedRecentSearches = () => {
    const recentSearches = JSON.parse(localStorage.getItem("recentSearches"));
    if (!recentSearches || !recentSearches.length) return;
    const wrapper = document.querySelector(".js-recent-search-wrapper");
    const list = document.querySelector(".js-recent-search-list");
    const template = list.querySelector(".js-recent-search-template");

    recentSearches.forEach((term) => {
      const clone = template.cloneNode(true);
      clone.querySelector("span").innerText = term;
      clone.classList.remove("js-recent-search-template");
      list.appendChild(clone);
    });

    wrapper.classList.remove("--is-hidden");
  };

  openSearchBtn.addEventListener("click", () => {
    modal.show();
  });

  searchInput.addEventListener("input", () => {
    submitBtn.disabled = searchInput.value.length <= 0;
  });

  submitBtn.addEventListener("click", (e) => {
    e.preventDefault();

    let recentSearches = JSON.parse(localStorage.getItem("recentSearches"));

    if (recentSearches && recentSearches.length) {
      recentSearches.unshift(searchInput.value);
    } else {
      recentSearches = [searchInput.value];
    }

    localStorage.setItem("recentSearches", JSON.stringify(recentSearches.slice(0, 5)));

    searchForm.submit();
  });

  seedRecentSearches();
};

export default initHeaderSearchModal;
